import React, { useState } from "react";
import "../css/ActivitiesGallery.css";
// Sample images for each activity (replace with appropriate paths).
import clay1 from "../asset/Activities/Clay activity 2024 25/IMG-20241007-WA0018.jpg";
import clay2 from "../asset/Activities/Clay activity 2024 25/IMG-20241007-WA0004.jpg";
import clay3 from "../asset/Activities/Clay activity 2024 25/IMG-20241007-WA0005.jpg";
import clay4 from "../asset/Activities/Clay activity 2024 25/IMG-20241007-WA0006.jpg";
import clay5 from "../asset/Activities/Clay activity 2024 25/IMG-20241007-WA0007.jpg";
import clay6 from "../asset/Activities/Clay activity 2024 25/IMG-20241007-WA0009.jpg";
import clay7 from "../asset/Activities/Clay activity 2024 25/IMG-20241007-WA0010.jpg";
import clay8 from "../asset/Activities/Clay activity 2024 25/IMG-20241007-WA0011.jpg";
import clay9 from "../asset/Activities/Clay activity 2024 25/IMG-20241007-WA0012.jpg";
import clay10 from "../asset/Activities/Clay activity 2024 25/IMG-20241007-WA0013.jpg";

import cleanliness1 from "../asset/Activities/cleanliness activity/1729002956011.jpg";
import cleanliness2 from "../asset/Activities/cleanliness activity/1729002956011.jpg";
import cleanliness3 from "../asset/Activities/cleanliness activity/1729002956017.jpg";
import cleanliness4 from "../asset/Activities/cleanliness activity/1729002956036.jpg";
import cleanliness5 from "../asset/Activities/cleanliness activity/1729002956041.jpg";
import cleanliness6 from "../asset/Activities/cleanliness activity/1729002956060.jpg";
import cleanliness7 from "../asset/Activities/cleanliness activity/1729002956134.jpg";
import cleanliness8 from "../asset/Activities/cleanliness activity/1729002956142.jpg";
import cleanliness9 from "../asset/Activities/cleanliness activity/1729002956157.jpg";
import cleanliness10 from "../asset/Activities/cleanliness activity/1729002956177.jpg";

import drawing1 from "../asset/Activities/Drawing and essay writing competition/1729003021475.jpg";
import drawing2 from "../asset/Activities/Drawing and essay writing competition/1729003021483.jpg";
import drawing3 from "../asset/Activities/Drawing and essay writing competition/1729003021495.jpg";
import drawing4 from "../asset/Activities/Drawing and essay writing competition/1729003021507.jpg";
import drawing5 from "../asset/Activities/Drawing and essay writing competition/1729003021519.jpg";
import drawing6 from "../asset/Activities/Drawing and essay writing competition/1729003021532.jpg";
import drawing7 from "../asset/Activities/Drawing and essay writing competition/1729003021542.jpg";
import drawing8 from "../asset/Activities/Drawing and essay writing competition/1729003021551.jpg";
import drawing9 from "../asset/Activities/Drawing and essay writing competition/1729003021563.jpg";
import drawing10 from "../asset/Activities/Drawing and essay writing competition/1729003021576.jpg";

import eating1 from "../asset/Activities/Healthy eating week 24-25/20240628_094251.jpg";
import eating2 from "../asset/Activities/Healthy eating week 24-25/20240628_094300.jpg";
import eating3 from "../asset/Activities/Healthy eating week 24-25/20240628_094313.jpg";
import eating4 from "../asset/Activities/Healthy eating week 24-25/20240628_094656.jpg";
import eating5 from "../asset/Activities/Healthy eating week 24-25/20240628_094708.jpg";
import eating6 from "../asset/Activities/Healthy eating week 24-25/20240628_094903.jpg";
import eating7 from "../asset/Activities/Healthy eating week 24-25/20240628_094914.jpg";
import eating8 from "../asset/Activities/Healthy eating week 24-25/20240628_144726.jpg";
import eating9 from "../asset/Activities/Healthy eating week 24-25/20240628_144833.jpg";
import eating10 from "../asset/Activities/Healthy eating week 24-25/20240628_144855.jpg";

import singing1 from "../asset/Activities/Singing/IMG_20230112_154703.jpg";
import singing2 from "../asset/Activities/Singing/IMG_20230112_154727.jpg";
import singing3 from "../asset/Activities/Singing/IMG_20230112_154908.jpg";
import singing4 from "../asset/Activities/Singing/IMG_20230112_154924.jpg";
import singing5 from "../asset/Activities/Singing/IMG_20230112_155119.jpg";
import singing6 from "../asset/Activities/Singing/IMG_20230112_155128.jpg";
import singing7 from "../asset/Activities/Singing/IMG_20230112_155136.jpg";
import singing8 from "../asset/Activities/Singing/IMG_20230112_155159.jpg";
import singing9 from "../asset/Activities/Singing/IMG_20230112_155201.jpg";
import singing10 from "../asset/Activities/Singing/IMG_20230112_155520.jpg";

import skating1 from "../asset/Activities/Skating/WhatsApp Image 2023-01-07 at 7.14.32 PM.jpeg";
import skating2 from "../asset/Activities/Skating/WhatsApp Image 2023-01-07 at 7.14.37 PM.jpeg";
import skating3 from "../asset/Activities/Skating/WhatsApp Image 2023-01-07 at 7.14.38 PM.jpeg";
import skating4 from "../asset/Activities/Skating/WhatsApp Image 2023-01-07 at 7.14.40 PM.jpeg";
import skating5 from "../asset/Activities/Skating/WhatsApp Image 2023-01-07 at 7.14.43 PM.jpeg";
import skating6 from "../asset/Activities/Skating/WhatsApp Image 2023-01-07 at 7.14.50 PM.jpeg";
import skating7 from "../asset/Activities/Skating/WhatsApp Image 2023-01-07 at 7.14.51 PM (1).jpeg";
import skating8 from "../asset/Activities/Skating/WhatsApp Image 2023-01-07 at 7.14.51 PM (2).jpeg";
import skating9 from "../asset/Activities/Skating/WhatsApp Image 2023-01-07 at 7.20.23 PM.jpeg";
import skating10 from "../asset/Activities/Skating/WhatsApp Image 2023-01-07 at 7.14.32 PM.jpeg";

import taekwondo1 from "../asset/Activities/Taekwondo/1733151038404.jpg";
import taekwondo2 from "../asset/Activities/Taekwondo/1733151038432.jpg";
import taekwondo3 from "../asset/Activities/Taekwondo/1733151038461.jpg";
import taekwondo4 from "../asset/Activities/Taekwondo/1733151038488.jpg";
import taekwondo5 from "../asset/Activities/Taekwondo/1733151038518.jpg";
import taekwondo6 from "../asset/Activities/Taekwondo/1733151038551.jpg";
import taekwondo7 from "../asset/Activities/Taekwondo/1733151038580.jpg";
import taekwondo8 from "../asset/Activities/Taekwondo/1733151038610.jpg";
import taekwondo9 from "../asset/Activities/Taekwondo/1733151038404.jpg";
import taekwondo10 from "../asset/Activities/Taekwondo/1733151038404.jpg";

const Activities = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const activities = [
    {
      title: "Clay Activities",
      description:
        "Unleashing creativity through clay modeling, shaping unique crafts.",
      images: [
        clay1,
        clay2,
        clay3,
        clay4,
        clay5,
        clay6,
        clay7,
        clay8,
        clay9,
        clay10,
      ],
    },
    {
      title: "Cleanliness",
      description:
        "Instilling good habits through engaging cleanliness activities.",
      images: [
        cleanliness1,
        cleanliness2,
        cleanliness3,
        cleanliness4,
        cleanliness5,
        cleanliness6,
        cleanliness7,
        cleanliness8,
        cleanliness9,
        cleanliness10,
      ],
    },
    {
      title: "Drawing and Essay",
      description:
        "Fostering imagination through drawing and essay writing exercises.",
      images: [
        drawing1,
        drawing2,
        drawing3,
        drawing4,
        drawing5,
        drawing6,
        drawing7,
        drawing8,
        drawing9,
        drawing10,
      ],
    },
    {
      title: "Healthy Eating",
      description:
        "Promoting nutritious habits with interactive healthy eating sessions.",
      images: [
        eating1,
        eating2,
        eating3,
        eating4,
        eating5,
        eating6,
        eating7,
        eating8,
        eating9,
        eating10,
      ],
    },
    {
      title: "Singing",
      description:
        "Encouraging musical talent and vocal expression through singing.",
      images: [
        singing1,
        singing2,
        singing3,
        singing4,
        singing5,
        singing6,
        singing7,
        singing8,
        singing9,
        singing10,
      ],
    },
    {
      title: "Skating",
      description:
        "Enhancing balance and coordination with fun skating events.",
      images: [
        skating1,
        skating2,
        skating3,
        skating4,
        skating5,
        skating6,
        skating7,
        skating8,
        skating9,
        skating10,
      ],
    },
    {
      title: "Taekwondo",
      description:
        "Building discipline and self-defense skills through Taekwondo training.",
      images: [
        taekwondo1,
        taekwondo2,
        taekwondo3,
        taekwondo4,
        taekwondo5,
        taekwondo6,
        taekwondo7,
        taekwondo8,
        taekwondo9,
        taekwondo10,
      ],
    },
  ];

  const openImage = (image) => {
    setCurrentImage(image);
    setIsOpen(true);
  };

  const closeImage = () => {
    setIsOpen(false);
    setCurrentImage(null);
  };

  return (
    <div className="activities-container">
      <h1 className="activities-head">Activities Gallery</h1>
      <p className="activities-intro">
        "Discover the diverse activities we offer to inspire, engage, and
        nurture young minds. Here's a glimpse into our world of fun and
        learning."
      </p>
      {activities.map((activity, index) => (
        <div key={index} className="activity-section">
          <h2 className="activity-title">{activity.title}</h2>
          <p className="activity-description">{activity.description}</p>
          <div className="activity-gallery">
            {activity.images.map((image, idx) => (
              <div
                key={idx}
                className="activity-item"
                onClick={() => openImage(image)}
              >
                <img src={image} alt={`${activity.title} ${idx}`} />
              </div>
            ))}
          </div>
        </div>
      ))}

      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-button" onClick={closeImage}>
              ×
            </button>
            <img
              className="modal-image"
              src={currentImage}
              alt="Expanded view"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Activities;
